const WonderOwner = {
    CAPITAL: 1,
    EGYPT: 2,
    CHINA: 3,
    MAYA: 4,
    VIKINGS: 5,
    ALLIED_CAPITAL: 6,
    ARABIA: 7,
    isAlliedCapital: function (owner) {
        return WonderOwner.EGYPT === owner ||
            WonderOwner.CHINA === owner ||
            WonderOwner.MAYA === owner ||
            WonderOwner.VIKINGS === owner ||
            WonderOwner.ARABIA === owner;
    }
};
export default WonderOwner;
